// Operation slug logic for OpenAPI tabs in the admin. MUST stay in sync
// with apps/public/lib/source.ts → listOpenApiOperations so visibility
// decisions made in admin map to the slugs the public renderer uses for
// /openapi/<tabId>/<opSlug> URLs.

const HTTP_METHODS = [
  "get",
  "post",
  "put",
  "delete",
  "patch",
  "options",
  "head",
  "trace",
] as const;
export type HttpMethod = (typeof HTTP_METHODS)[number];

export type ListedOperation = {
  slug: string;
  path: string;
  method: HttpMethod;
  title: string;
  tag: string | null;
};

function slugify(input: string): string {
  return (
    input
      .normalize("NFKD")
      .replace(/[̀-ͯ]/g, "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "")
      .slice(0, 80) || "op"
  );
}

export function listOperationsFromSpec(
  spec: Record<string, any> | null | undefined,
): ListedOperation[] {
  if (!spec || typeof spec !== "object") return [];
  const out: ListedOperation[] = [];
  const seen = new Map<string, number>();
  const paths = (spec.paths ?? {}) as Record<string, any>;
  for (const path of Object.keys(paths)) {
    const pathItem = paths[path];
    if (!pathItem || typeof pathItem !== "object") continue;
    for (const method of HTTP_METHODS) {
      const op = pathItem[method];
      if (!op || typeof op !== "object") continue;
      const baseSlug = op.operationId
        ? slugify(String(op.operationId))
        : `${method}-${slugify(path)}`;
      const n = (seen.get(baseSlug) ?? 0) + 1;
      seen.set(baseSlug, n);
      const slug = n === 1 ? baseSlug : `${baseSlug}-${n}`;
      const title =
        (op.summary && String(op.summary).trim()) ||
        (op.operationId && String(op.operationId)) ||
        `${method.toUpperCase()} ${path}`;
      const tags =
        Array.isArray(op.tags) && op.tags.length > 0 ? op.tags[0] : null;
      out.push({
        slug,
        path,
        method,
        title,
        tag: tags ? String(tags) : null,
      });
    }
  }
  return out;
}
